import { Link } from 'react-router-dom';
import { mediaUrl } from '../api/contentApi';
import { contentPath, formatDate, typeInfo } from '../content/contentTypes';

export default function ContentCard({ entry, media, featured = false }) {
  const src = mediaUrl({ url: entry.featuredImageUrl }) || mediaUrl(media?.[entry.featuredMediaId]);
  const date = formatDate(entry.sourceModified || entry.importedAt);

  return (
    <article className={`card${featured ? ' card-featured' : ''}`}>
      <Link to={contentPath(entry)} className="card-link">
        <div className="card-media">
          {src ? (
            <img src={src} alt={entry.featuredImageAlt || ''} loading="lazy" />
          ) : (
            <div className="card-placeholder" aria-hidden="true">{entry.title.slice(0, 1)}</div>
          )}
        </div>
        <div className="card-body">
          <p className="eyebrow">{entry.categoryName || typeInfo(entry.type).label}</p>
          <h2 className="card-title">{entry.title}</h2>
          {entry.excerpt && <p className="card-excerpt">{entry.excerpt}</p>}
          <p className="card-meta">
            {[entry.authorName, date, `${entry.readingTimeMinutes || 1} min read`].filter(Boolean).join(' \u00b7 ')}
          </p>
        </div>
      </Link>
    </article>
  );
}
